//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


//import parse from 'date-fns/parse'
//import format from 'date-fns/format'

//import qs from "qs";

export default {
  props: {
    city: {
      type: String,
      default: null
    },
    keyword: {
      type: String,
      default: null
    }
  },

  computed: {
    searchActive() {
      // || this.search.sort_by != 'random' || this.search.subcategory.length > 0
      return this.activeFilters.search_term.length > 0 || this.activeFilters.sort_by != 'random';
    },
    filteredPlaces() {
      let arr = this.places;
      let filteredArr = arr.reduce((acc, current) => {
        const x = acc.find(item => item.venue.id === current.venue.id);
        if (!x) {
          return acc.concat([current]);
        } else {
          return acc;
        }
      }, []);
      return this.places;
    },
  },
  watch: {
    search: {
      deep: true,
      handler() {
        console.log('length', this.search.keyword.length);
      }
    }
  },
  components: {

  },
  filters: {

  },
  data() {
    return { 
      
      loading: true,
      running: false,
      hideDirectory: false,
      firstRun: true,
      places: [],
      search: {
        keyword: '',
        city: '',
        subcategory: '',
        page: 1,
        sort_by: 'most viewed',
        per_page: 10,
      },
      activeFilters: {
        api_key: '42e8526689b8b663b2969d9604eec906',
        limit: 10,
        page: 1,
        radius: 100,
        ew_base_region_id: 0,
        region_id: '',
        data_type: '',
        region: '',
        city: '',
        domain_analytics: '',
        ew_user_cookie: '',
        subcategory: '',
        sort_by: 'most viewed',
        search_term: '',
        category: 'shopping',
        search_domain: 'https://visitkinston.com',
      },
      resultCount: 0,
      clearResults: false,
      showLoadMore: false,
      keywordActive: false,
      catOptions: [
        { value: 'agritourism', label: 'Agritourism' },
        { value: 'attraction', label: 'Attractions' },
        { value: 'covid-friendly', label: 'COVID-Friendly'},
        { value: 'dining', label: 'Dining' },
        { value: 'history', label: 'History' },
        { value: 'recreation', label: 'Recreation' },
        { value: 'shopping', label: 'Shopping' },
        { value: 'weddings', label: 'Weddings' },
      ]

     
    }
  },
  mounted() {


    this.getPlaces();
 

  },
  methods: {
    getThumbnail(place) {
      return 'https://api.everwondr.com'+place.items[0].upload_source.replace('_o.', '_n.');
    },
    searchPlaces() {
      this.search.page = 1;
      this.places = [];
      this.clearResults = true;

      this.getPlaces();

    },
    onCatChange(event) {
      this.setSubcategory(event.target.value);
    },
    setSubcategory(sub) {
      if (sub != this.search.subcategory) {
        this.search.subcategory = sub;
      } else {
        this.search.subcategory = '';
      }
      this.search.page = 1;
      this.getPlaces();
    },
    clearSearch() {
      this.search.keyword = '';
      this.search.subcategory = '';
      this.search.sort_by = 'most viewed';
      this.search.page = 1;
      this.getPlaces();
    },
    loadMore() {
      this.search.page++;
      this.getPlaces();
    },
    getPlaces() {

      if (this.running) {
        return;
      } else {
        this.running = true;
      }

      this.loading = true;

      if (this.search.page == 1) {
        this.places = [];
      }

      let self = this;

      let url = 'https://api.everwondr.com/visit/search_ajax';

      this.activeFilters.search_term = this.search.keyword;
      this.activeFilters.city = this.search.city;
      this.activeFilters.sort_by = this.search.sort_by;
      this.activeFilters.subcategory = this.search.subcategory;
      this.activeFilters.page = this.search.page;

      if (this.city) {
       this.activeFilters.city = this.city;
      }

      if (this.keyword) {
        this.activeFilters.search_term = this.keyword;
      }

      this.keywordActive = this.keyword;


      let params = {
        data: this.activeFilters,
        region_id: 0,
      }


     $.ajax({
          type: "POST",
          url:url,
          //contentType: "application/json; charset=utf-8",
          data: params,
          //dataType: "json",
          success: function (response) {

            

                if ( self.clearResults ) {
                  self.places = [];
                  self.clearResults = false;
                }

                self.resultCount = parseInt(response.total);

                self.places = self.places.concat(response.venues);
                console.log(self.places);

                if (self.firstRun) {
                  if (self.places.length < 1) {
                    self.hideDirectory = true;
                  } 
                  self.firstRun = false;
                }

                if ( response.venues.length == self.search.per_page ) {
                  self.showLoadMore = true;
                } else {
                  self.showLoadMore = false;
                }

                self.loading = false;
                self.running = false;





          },
          error: function (xhr, status, error) {
              
          }
      });

    }
  }
}




// WEBPACK FOOTER //
// ./scripts/components/Shopping.vue